import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);
  const [tip, setTip] = useState('');

  return (
    <section id="faq" className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 items-start">
          <div className="lg:col-span-2">
            <p className="text-xs font-medium text-primary-700 tracking-wide flex items-center gap-2">
              <span className="w-6 h-px bg-primary-300"></span>
              常见问答 · 先把瓜吃明白
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              关于吃瓜捷克，最常被问的六个问题
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              别急着下结论。下面是围绕身份、年龄、照片与同名账号的常见疑问，
              每条都尽量把「能确认」和「只是猜」讲清楚。
            </p>

            <div className="mt-8 space-y-3">
              {faqItems.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div
                    key={f.q}
                    className={`rounded-lg border bg-background-50 overflow-hidden transition-colors ${
                      open ? 'border-accent-300' : 'border-background-200'
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      className="w-full flex items-center gap-3 px-4 md:px-5 py-4 text-left"
                    >
                      <span
                        className={`w-6 h-6 shrink-0 rounded-full flex items-center justify-center text-xs font-medium ${
                          open ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="flex-1 text-sm md:text-[15px] font-medium text-foreground-950 leading-relaxed">
                        {f.q}
                      </span>
                      <i
                        className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    {open && (
                      <div className="px-4 md:px-5 pb-5 pt-0 pl-[52px] md:pl-[60px]">
                        <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200 pt-3.5">
                          {f.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <aside className="lg:sticky lg:top-24">
            <div className="rounded-xl border border-accent-300 bg-accent-50 p-5 md:p-6">
              <div className="w-10 h-10 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-lg mb-4">
                <i className="ri-shield-check-line" aria-hidden="true"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950">这份档案为什么可信</h3>
              <ul className="mt-4 space-y-3 text-sm text-foreground-700 leading-relaxed">
                <li className="flex gap-2.5">
                  <i className="ri-checkbox-circle-line text-accent-700 mt-0.5" aria-hidden="true"></i>
                  只收录可被公开查证的动态与作品，不编造身份细节。
                </li>
                <li className="flex gap-2.5">
                  <i className="ri-checkbox-circle-line text-accent-700 mt-0.5" aria-hidden="true"></i>
                  每条判断都标注来源性质：认证动态 / 网友推测 / 未核实。
                </li>
                <li className="flex gap-2.5">
                  <i className="ri-checkbox-circle-line text-accent-700 mt-0.5" aria-hidden="true"></i>
                  对仿冒账号与「独家实锤」一律保持警惕并明确提示。
                </li>
              </ul>

              <div className="mt-5 border-t border-accent-200 pt-4">
                <h4 className="text-sm font-medium text-foreground-950 mb-2.5">发现资料有误？</h4>
                <textarea
                  rows={3}
                  maxLength={200}
                  placeholder="写下一句你认为有误或缺失的信息（限 200 字）"
                  aria-label="提交资料纠错"
                  className="w-full text-sm px-3 py-2 rounded-md bg-background-50 border border-accent-200 placeholder:text-foreground-400 outline-none focus:border-accent-400 resize-none"
                ></textarea>
                <button
                  type="button"
                  onClick={() =>
                    setTip('已记录你的提醒，我们会核对公开动态后统一更新。')
                  }
                  className="mt-2 inline-flex items-center justify-center gap-1.5 text-sm font-medium bg-accent-500 text-background-50 hover:bg-accent-600 px-4 py-2 rounded-md w-full whitespace-nowrap"
                >
                  提交纠错反馈
                </button>
                {tip && (
                  <p className="mt-2 text-xs text-accent-800 flex items-center gap-1.5">
                    <i className="ri-check-line" aria-hidden="true"></i>
                    {tip}
                  </p>
                )}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}